import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./Components/Header/Header"
import Hero from "./Components/Hero/Hero"
import Numbers from "./Components/Numbers/Numbers"
import About from "./Components/About/About"
import Video from "./Components/video/Video"
import OurFoods from "./Components/OurFoods/OurFoods"
import Footer from "./Components/footer/Footer"

function App() {
  return (
    <div>
      <Header/>
      <Hero/>
      <Numbers/>
      <About/>
      <section className="about second container">
        <div className="content">
          <p className="title">
            We make everything by hand with the best possible ingredients.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et
            purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat
            tellus.Far far away, behind the word mountains, far from the
            countries Vokalia and Consonantia, there live the blind texts.
          </p>
          <ul>
            <li>
              <i class="fa-solid fa-check"></i> Etiam sed dolor ac diam
              volutpat.
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Erat volutpat aliquet imperdiet.
            </li>
            <li>
              <i class="fa-solid fa-check"></i> purus a odio finibus bibendum.
            </li>
          </ul>
          <button>Learn More</button>
        </div>
        <div className="img">
          <img src="first-meal.jpg" alt="meal" />
        </div>
      </section>
      <Video/>
      <OurFoods/>
      <Footer/>
    
      
      
    
      
      
    </div>
  );
}

export default App;
